import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconUpload } from 'src/assets/icons/Upload';
import { CUSTOM_BUTTON_VARIANT, CustomButton } from 'src/components/CustomButton';
import { RESOURCE_CONTENT_TYPE } from 'src/data/performance';

import { PROMPT_MENU_TYPE } from '../../lib';
import { ItemsResource } from '../ItemsResource';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  resourceType: PropTypes.oneOf(Object.values(RESOURCE_CONTENT_TYPE)).isRequired,
  resources: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAction: PropTypes.func.isRequired,
  onUploadClick: PropTypes.func.isRequired,
  quickSearchMode: PropTypes.bool,
  menuType: PropTypes.oneOf(Object.values(PROMPT_MENU_TYPE)).isRequired,
  noTags: PropTypes.bool,
};

const defaultProps = {
  className: '',
  quickSearchMode: false,
  noTags: false,
};

export const MenuContentResource = ({
  className,
  resourceType,
  resources,
  onAction,
  onUploadClick,
  quickSearchMode,
  menuType,
  noTags,
}) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <CustomButton
        onClick={() => onUploadClick(resourceType)}
        startIcon={<IconUpload />}
        variant={CUSTOM_BUTTON_VARIANT.outlined}
      >
        Upload
      </CustomButton>

      {resources?.length > 0 && (
        <ItemsResource
          resources={resources}
          onAction={onAction}
          quickSearchMode={quickSearchMode}
          menuType={menuType}
          noTags={noTags}
        />
      )}
    </div>
  );
};

MenuContentResource.displayName = 'MenuContentResource';
MenuContentResource.propTypes = propTypes;
MenuContentResource.defaultProps = defaultProps;
